import { render } from "./C4Wizard.vue?vue&type=template&id=0d90bc9d"
import script from "./C4Wizard.vue?vue&type=script&lang=js"
export * from "./C4Wizard.vue?vue&type=script&lang=js"

import "./C4Wizard.vue?vue&type=style&index=0&id=0d90bc9d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__